import { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import LoginPage from "./Components/Login/LoginPage";
// import Dashboard from "./Components/Dashboard/Dashboard";
import PointOfSales from "./Components/PointOfSales/PointOfSales";
import TopTen from "./Components/TopTen/TopTen";
import Inventory from "./Components/Inventory/Inventory";
import Accounts from "./Components/Accounts/Accounts";
import PurchasePlans from "./Components/PurchasePlans/PurchasePlans";
import Crm from "./Components/Crm/Crm";
import InvoiceWiseStock from "./Components/Inventory/InvoiceWiseStock";
import BarCodeScanner from "./Components/BarCodeScanner/BarCodeScanner";
import BluetoothPrinter from "./Components/BluetoothPrinter/BluetoothPrint";
import DashboardComponent from "./Components/Dashboard/Dashboard";
import TopTenInvoices from "./Components/TopTen/TopTenInvoices";
import TopTenBrands from "./Components/TopTen/TopTenBrands";
import TopTenPrices from "./Components/TopTen/TopTenPrices";
import TopTenSalesMan from "./Components/TopTen/TopTenSalesMan";
import TopTenProducts from "./Components/TopTen/TopTenProducts";
import StockPoint from "./Components/Inventory/StockPoint";
import PurchaseTypeWiseStock from "./Components/Inventory/PurchaseTypeWiseStock";
import ProductWiseStock from "./Components/Inventory/ProductWiseStock";
import HSNWiseStock from "./Components/Inventory/HSNWiseStock";
import BrandWiseStock from "./Components/Inventory/BrandWiseStock";
import DealerWiseStock from "./Components/Inventory/DealerWiseStock";
import GropuWiseStock from "./Components/Inventory/GroupWiseStock";
import BarCodeCheck from "./Components/Inventory/BarCodeCheck";
import OutstandingCustomers from "./Components/Accounts/OutstandingCustomers";
import OutstandingDealers from "./Components/Accounts/OutstandingDealers";
import CashBook from "./Components/Accounts/CashBook";
import BankStatement from "./Components/Accounts/BankStatement";
import RecieptRegister from "./Components/Accounts/RecieptRegister";
import PaymentReciept from "./Components/Accounts/PaymentRegister";
import PurchaseRegister from "./Components/Accounts/PurchaseRegister";
import JournalRegister from "./Components/Accounts/JournalRegister";
import SalesMenWiseCommission from "./Components/Accounts/SalesMenWiseCommission";
import CommodityWisePurchase from "./Components/PurchasePlans/CommodityWisePurchase";
import ProductWisePurchase from "./Components/PurchasePlans/ProductWisePurchase";
import DealerWisePurchase from "./Components/PurchasePlans/DealerWisePurchse";
import HSNWisePurchase from "./Components/PurchasePlans/HSNWisePurchase";
import BrandWisePurchase from "./Components/PurchasePlans/BrandWisePurchase";
import TaxWisePurchase from "./Components/PurchasePlans/TaxWisePurchase";
import TodayBirthDays from "./Components/Crm/TodayBirthDays";
import TodayAnniversaries from "./Components/Crm/TodayAnniversaries";
import TotalDues from "./Components/Crm/TotalDues";
import Graphs from "./Components/Crm/Graphs";
import SaleReturnScanner from "./Components/BarCodeScanner/Salereturnscanner";
import ExchangeBill from "./Components/ExchangeBill/ExchangeBill";

function App() {
  const tenantName = localStorage.getItem("tenantName");
  const [isAuthenticated, setIsAuthenticated] = useState(
    // localStorage.getItem("isLoggedIn") === "true"
    tenantName,
  );

  const handleLogin = (name) => {
    // localStorage.setItem("isLoggedIn", "true"); // Store login status
    setIsAuthenticated(name);
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage onLogin={handleLogin} />} />
        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Routes>
                <Route path="/home" element={<DashboardComponent />} />
                <Route path="/point-of-sales" element={<PointOfSales />} />
                <Route path="/top-ten" element={<TopTen />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/purchase-plans" element={<PurchasePlans />} />
                <Route path="/crm" element={<Crm />} />
                <Route path="/graphs" element={<Graphs />} />
                <Route path="/bar-code-check" element={<BarCodeCheck />} />
                <Route
                  path="/invoice-wise-stock"
                  element={<InvoiceWiseStock />}
                />
                <Route path="/bar-code-scanner" element={<BarCodeScanner />} />
                <Route path="/sale-return" element={<SaleReturnScanner />} />
                <Route path="/bluetooth" element={<BluetoothPrinter />} />
                <Route path="/top-ten-invoices" element={<TopTenInvoices />} />
                <Route path="/top-ten-brands" element={<TopTenBrands />} />
                <Route path="/top-ten-prices" element={<TopTenPrices />} />
                <Route path="/top-ten-salesman" element={<TopTenSalesMan />} />
                <Route path="/top-ten-products" element={<TopTenProducts />} />
                <Route path="/stock-point" element={<StockPoint />} />
                <Route
                  path="/commodity-wise"
                  element={<PurchaseTypeWiseStock />}
                />
                <Route path="/product-wise" element={<ProductWiseStock />} />
                <Route path="/hsn-wise" element={<HSNWiseStock />} />
                <Route path="/brand-wise" element={<BrandWiseStock />} />
                <Route path="/dealer-wise" element={<DealerWiseStock />} />
                <Route path="/group-wise" element={<GropuWiseStock />} />
                <Route path="/bar-code-check" element={<BarCodeCheck />} />
                <Route
                  path="/outstanding-customers"
                  element={<OutstandingCustomers />}
                />
                <Route
                  path="/outstanding-dealers"
                  element={<OutstandingDealers />}
                />
                <Route path="/cash-book" element={<CashBook />} />
                <Route path="/bank-statement" element={<BankStatement />} />
                <Route path="/receipt-register" element={<RecieptRegister />} />
                <Route
                  path="/payment-receipt-register"
                  element={<PaymentReciept />}
                />
                <Route
                  path="/purchase-register"
                  element={<PurchaseRegister />}
                />
                <Route path="/journal-register" element={<JournalRegister />} />
                <Route
                  path="/salesmen-commission"
                  element={<SalesMenWiseCommission />}
                />
                <Route
                  path="/purchase/commodity-wise"
                  element={<CommodityWisePurchase />}
                />
                <Route
                  path="/purchase/product-wise"
                  element={<ProductWisePurchase />}
                />
                <Route
                  path="/purchase/dealer-wise"
                  element={<DealerWisePurchase />}
                />
                <Route
                  path="/purchase/hsn-wise"
                  element={<HSNWisePurchase />}
                />
                <Route
                  path="/purchase/brand-wise"
                  element={<BrandWisePurchase />}
                />
                <Route
                  path="/purchase/tax-wise"
                  element={<TaxWisePurchase />}
                />
                <Route path="/crm/birthdays" element={<TodayBirthDays />} />
                <Route
                  path="/crm/anniversaries"
                  element={<TodayAnniversaries />}
                />
                <Route path="/crm/dues" element={<TotalDues />} />
                <Route path="/graphs" element={<Graphs />} />
                <Route path="/exchange-bill" element={<ExchangeBill />} />
              </Routes>
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
